// removed by extract-text-webpack-plugin
module.exports = {"koala":"#c5c7cb","brand":"#2f75c1","polarBear":"#f2f3f5","this":"EventRSVPForm__this___3B7W6","buttonGroup":"EventRSVPForm__buttonGroup___sm0iy","button":"EventRSVPForm__button___2RWki","smallButton":"EventRSVPForm__smallButton___2uCI6","mediumButton":"EventRSVPForm__mediumButton___3D4F-","selected":"EventRSVPForm__selected___2Wyuf"};


//////////////////
// WEBPACK FOOTER
// ./src/payments/components/styles/EventRSVPForm.css
// module id = 1790
// module chunks = 4